import React, { useEffect } from 'react';
import { Route, Routes } from "react-router-dom";
import RequireAuth from "./hoc/RequireAuth";
import AdminRoutes from "./routes/AdminRoutes";
import { useDispatchEx, useSelectorEx } from './hooks/redux';
import { asyncCheckAction } from './redux/slices/auth/authAction';
import Login from "./pages/Admin/Login";
import OrdersPage from "./pages/Admin/OrdersPage";
import OrderPage from "./pages/Admin/OrderPage";
import { ToastContainer } from "react-toastify";
import CurrencyRatesPage from "./pages/Admin/CurrencyRatesPage";

function App() {
    const dispatch = useDispatchEx();
    const { user } = useSelectorEx(state => state.auth);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token && !user) {
            dispatch(asyncCheckAction());
        }
    }, [dispatch, user]);

    return (
        <>
            <ToastContainer />
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route element={<RequireAuth role={"ADMIN"} />}>
                    <Route path="/admin" element={<AdminRoutes />}>
                        <Route path="orders">
                            {/* Валюта + Статус + Пагинация */}
                            <Route path="currency/:currencyCode/status/:statusCode/page/:pageNumber" element={<OrdersPage />} />
                            <Route path="currency/:currencyCode/status/:statusCode" element={<OrdersPage />} />

                            {/* Только Валюта + Пагинация */}
                            <Route path="currency/:currencyCode/page/:pageNumber" element={<OrdersPage />} />
                            <Route path="currency/:currencyCode" element={<OrdersPage />} />

                            {/* Только Статус + Пагинация */}
                            <Route path="status/:statusCode/page/:pageNumber" element={<OrdersPage />} />
                            <Route path="status/:statusCode" element={<OrdersPage />} />

                            {/* Только Пагинация */}
                            <Route path="page/:pageNumber" element={<OrdersPage />} />

                            {/* Конкретный заказ */}
                            <Route path=":orderID" element={<OrderPage />} />

                            {/* Базовый роут */}
                            <Route index element={<OrdersPage />} />
                        </Route>
                        <Route path="currency-rates" element={<CurrencyRatesPage />} />
                        <Route index element={<OrdersPage />} />
                    </Route>
                </Route>
            </Routes>
        </>
    );
}

export default App;